import { render, staticRenderFns } from "./outcome.vue?vue&type=template&id=1c488765"
import script from "./outcome.vue?vue&type=script&lang=js"
export * from "./outcome.vue?vue&type=script&lang=js"
import style0 from "./outcome.vue?vue&type=style&index=0&id=1c488765&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports